import styled from "@emotion/styled";
import { Typography, Button } from "@trustpilot/businessapp-patternlibrary";
import { Text } from "ilenia";
import React from "react";
import { useHistory } from "react-router-dom";

import { ButtonWrapper, Container, ColoredText, HeaderWrapper } from "./shared";

const BigGrayText = styled.span({
  color: "var(--text-subtle)",
  fontWeight: 700,
  fontSize: "100px",
});

const NotFound = () => {
  const history = useHistory();

  return (
    <Container>
      <HeaderWrapper>
        <Typography variant="body-l">
          <BigGrayText>404</BigGrayText>
        </Typography>
      </HeaderWrapper>
      <Typography variant="display-s">
        <ColoredText color={"var(--trustpilot-brand-green-10)"}>
          <Text id="FallbackPages.notfound.title" />
        </ColoredText>
      </Typography>
      <Typography variant="body-l">
        <ColoredText color={"var(--text-default)"}>
          <Text id="FallbackPages.notfound.description" />
        </ColoredText>
      </Typography>

      <ButtonWrapper>
        <Button
          appearance="primary"
          onClick={() => {
            history.push("/dashboard");
          }}
          stretch
        >
          <Text id="FallbackPages.notfound.cta" />
        </Button>
      </ButtonWrapper>
    </Container>
  );
};

export default NotFound;
